import React, { useState } from 'react';
import MonacoEditor from '@monaco-editor/react';
import CompletionPopup from '../completion-popup';
import { serverURL } from '../../config/urls';
import { logEvent } from '@firebase/analytics';
import {analytics} from '../../config/firebase-logging';
import { useCareerContext } from '../career-context';

function TemperatureConverter() {
    const {
        isPopupOpen,
        setIsPopupOpen,
        startConfetti
    } = useCareerContext();
    const options = {scrollbar: {alwaysConsumeMouseWheel: false,},scrollBeyondLastLine: false,minimap: {enabled: false,}}

    const [code, setCode] = useState("def celcius_to_faranheit(temperature):\n\t# Write code here");
    const [output, setOutput] = useState('');
    const [isProblemFinished, setIsProblemFinished] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [temperatureOutput, setTemperatureOutput] = useState(null);

    function handleEditorChange(newValue, event) {
        setCode(newValue);
    }

    function handleInputChange(event) {
        setInputValue(event.target.value);
    }

    function handleTempConvert(event) {
        if (inputValue === "") {
            alert("Please enter a temperature")
            setTemperatureOutput(celciusToFaranheit(inputValue))
        } else if (isNaN(inputValue)) {
            alert("The given temperature is not a number")
            setTemperatureOutput(celciusToFaranheit(inputValue))
        } else {
            setTemperatureOutput(celciusToFaranheit(inputValue))
        }
    }

    function celciusToFaranheit(temperature) {
        let result = temperature * (9 / 5) + 32;
        return result.toFixed(1);
    }

    async function runCode() {
        if (process.env.REACT_APP_ENVIRONMENT === "production") {
            logEvent(analytics, 'career_interaction')
        }
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ code }),
        };
        const response = await fetch(serverURL + "/convert_temperature", requestOptions);
        const result = await response.json();
        if (result.error) {
            setIsProblemFinished(false);
            setOutput(result.error);
        } else if (result.verdict === "Fail") {
            setIsProblemFinished(false);
            setOutput(`Test password ${result.test} failed.\nExpected: ${result.expected}, got ${result.result} instead`)
        } else {
            setOutput("");
            setIsPopupOpen(true);
            startConfetti();
            setIsProblemFinished(true);
        }
    }

    function hidePopup() {
        setIsPopupOpen(false);
    }


    return (
        <>
            {isPopupOpen && <CompletionPopup title="All Test Cases Passed!" message="Great job, you passed all tests! Now try your program out!" hidePopup={hidePopup}/>}

            <h1 className='blue'>Temperature Conversion</h1>
            <p>
                Complete this function that converts a temperature from celcius to faranheit. The formula to convert celcius to temperature is F = (C * 9/5) + 32. Return the resulting temperature in faranheit. Just as a reminder, multiply numbers using <code>*</code> and divide using <code>/</code>.
            </p>
            <p>Examples</p>
            <ul>
                <li><code>celcius_to_faranheit(0)</code> returns <code>32</code></li>
                <li><code>celcius_to_faranheit(42)</code> returns <code>107.6</code> Don't worry about the precision of the decimal.</li>
                <li><code>celcius_to_faranheit(80)</code> returns <code>176</code></li>
            </ul>

            <div className='row' style={{alignItems: "flex-start"}}>
                <div style={{ width: (output || isProblemFinished) ? "50%" : "100%" }}>
                    <div className='editor-padding'></div>
                    <MonacoEditor theme='vs-dark' language='python' height="200px" value={code} onChange={handleEditorChange} options={options} />
                    <button className='primary-btn blue-bg' style={{marginTop: "5px"}} onClick={runCode}>Submit</button>
                </div>
                {isProblemFinished &&
                    (<div className='password-test'>
                        <input type="text" value={inputValue} onChange={handleInputChange} placeholder='Enter Temperature in Celcius' className='input-text' />
                        <button className='primary-btn' style={{marginTop: "10px"}} onClick={handleTempConvert}>Convert To Faranheit</button>
                        {temperatureOutput && <p>{temperatureOutput} Faranheit</p>}
                    </div>)}
                {output && <pre className='output' style={{height: "200px"}}>{output}</pre>}

            </div>
        </>
    );
}

export default TemperatureConverter;